<ppl-popover-dropdown>
  <ppl-menu
    [value]="value"
    [hasIcons]="false"
    (valueChanged)="valueChange.emit($event)">
    @for (option of options; track option) {
      <ppl-menu-item
        [value]="option.id"
        pplPopoverClose>
        {{ option.label }}
      </ppl-menu-item>
    }
  </ppl-menu>
</ppl-popover-dropdown>
